import React, { Component } from 'react';

class Map extends Component {

	render() {

		return <div className="google-map mb-0">
			<iframe
				title="Google Map de Artectum"
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15606.26896392884!2d-76.9943441!3d-12.0624954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c71e19458763%3A0x62608858daa16524!2sArtectum!5e0!3m2!1sen!2spe!4v1590597267201!5m2!1sen!2spe"
				width="100%"
				height="100%"
				frameBorder={0}
				allowFullScreen
				aria-hidden="false"
				tabIndex={0}
			/>
		</div>
	}
}

export default Map